import { module } from 'angular';
import App from '../../../app';

class SCR0706Controller {
	
	constructor ($scope, $uibModalInstance, $timeout, httpService, 
			utilService, gridService, popupService, codeService, data){
		this.$scope = $scope;
		this.$uibModalInstance = $uibModalInstance;
		this.$timeout = $timeout;
		this.httpService = httpService;
		this.gridService = gridService;
		this.utilService = utilService;
		this.popupService = popupService;
		this.codeService = codeService;
		this.data = data;
		
		this.initWindow('100%', '100%');
		this.initText();
		this.initSelect();
		this.initCode();
		
		this.$timeout(() => {
			this.setGridHeight();
			this.initGridOption();
			this.getDeployList();
			this.getMsglayout();
		});
	}
	
	initWindow(width, height){
		this.width = width;
		this.height = height;
		this.top = 100;
		this.left = 50;
		this.right = 50;
		this.zIndex = this.popupService.getModalZIndex();
	}
	
	initText(){
		this.text = {
			msgLayoutId: bxMsg('manageMsg.msgLayoutId'),
			msgName: bxMsg('manageMsg.msgName'),
			msgRegister: bxMsg('manageMsg.msgRegister'),
			msgVersion: bxMsg('manageMsg.msgVersion'),
			msgType: bxMsg('manageMsg.msgType'),
			msgRegisterDt: bxMsg('manageMsg.msgRegisterDt'),
			msgLayoutDiff: bxMsg('manageMsg.msgLayoutDiff'),
			fldEngNm: bxMsg('manageMsg.fldEngNm'),
			fldKorNm: bxMsg('manageMsg.fldKorNm'),
			msgRvsNo: bxMsg('manageMsg.msgRvsNo'),
			deploySys : bxMsg('manageDeploySystem.deploySys'),
			deploySysCd : bxMsg('manageDeploySystem.deploySysCd'),
			deploySysNm : bxMsg('manageDeploySystem.deploySysNm'),
			deploySysGrpCd : bxMsg('manageDeploySystem.deploySysGrpCd'),
			deploySysUrl : bxMsg('manageDeploySystem.deploySysNm'),
			deploySysDesc : bxMsg('manageDeploySystem.deploySysDesc'),
			deploySysDescPlaceHolder : bxMsg('manageDeploySystem.deploySysDescPlaceHolder'),
			depVersion : bxMsg('manageDeploySystem.depVersion'),
			currentVersion : bxMsg('manageDeploySystem.currentVersion'),
			deployVersion : bxMsg('manageEaiInterface.deployVersion'),
			deployDttm : bxMsg('manageEaiInterface.deployDttm'),
			dataTypeNm : bxMsg('manageEaiInterface.dataTypeNm'),
			fldLvNo : bxMsg('manageEaiInterface.fldLvNo'),
			msgLen : bxMsg('manageEaiInterface.msgLen'),
			arraySizeRefVal: bxMsg('manageMsg.arraySizeRefVal'),
			close : bxMsg('common.close'),
		}
	}
	
	initSelect(){
		this.select = this.gridService.getSelect(5);
	}
	
	initCode(){
		this.dataTypeList = this.codeService.getCodesByCdIdFromMem('DATA_TYPE');
	}
	
	initGridOption(){
		this.gridView = new RealGridJS.GridView('grid');
		this.dataProvider = new RealGridJS.LocalDataProvider();
		this.gridView.setDataSource(this.dataProvider);		
		this.gridService.setDefaultSetting(this.gridView);
		this.gridView.setCheckBar({visible: false});
		this.gridView.setDisplayOptions({fitStyle: 'evenFill'}); 
		
		this.dataProvider.setFields([
			{fieldName: "deployVersion"}, {fieldName: "deployDttm"}, {fieldName: "deploySysCd"},
			{
            	fieldName: "deployDttmTxt",
            	calculateCallback: (dataRow, fieldName, fieldNames, values) => {
            		return this.utilService.setRegDttm(values[fieldNames.indexOf('deployDttm')]);
        		}
    		}, 
        ]);
		
		this.gridView.setColumns([
			{ name: "deployVersion", fieldName: "deployVersion", header : { text: this.text.deployVersion } , width: 40, styles: { textAlignment: 'center' } },
			{ name: "deployDttmTxt", fieldName: "deployDttmTxt", header : { text: this.text.deployDttm }, width: 100, styles: { textAlignment: 'center' } },
			{ name: "deploySysCd", fieldName: "deploySysCd", header : { text: this.text.deploySys }, width: 100, styles: { textAlignment: 'center' } }
		]);
		
		this.gridView.onDataCellClicked = (grid, cell) => {
			// 그리드 diff 표시 
			this.currentGridView.setStyles({
				body: {
					dynamicStyles: null
				}
			});
			
			this.depGridView.setStyles({
				body: {
					dynamicStyles: null
				}
			});
			
			let row = grid.getValues(cell.itemIndex);
			this.getLayoutDiff(row.deployVersion);
		};
		
		this.depGridView = new RealGridJS.GridView('dep-grid');
		this.depDataProvider = new RealGridJS.LocalDataProvider();
		this.depGridView.setDataSource(this.depDataProvider);		
		this.gridService.setDefaultSetting(this.depGridView);
		this.depGridView.setCheckBar({visible: false});
		this.depGridView.setDisplayOptions({fitStyle: 'evenFill', rowHeight: 24, vscrollBar: true}); 
		this.depGridView.setEditOptions({deletable: true});
		this.depGridView.setSortingOptions({enabled: false});
		this.depGridView.setHeader({height: 30});
		
		this.depDataProvider.setFields(this.getVersionFields());
		this.depGridView.setColumns(this.getVersionColumns());
		this.depGridView.setSelectOptions({style: 'block'});
		
		this.depGridView.onTopItemIndexChanged = (grid, itemIndex) => {
			if(grid.getTopItem() === itemIndex) {
				this.currentGridView.setTopItem(itemIndex);
			}
		};
		
		this.currentGridView = new RealGridJS.GridView('current-grid');
		this.currentDataProvider = new RealGridJS.LocalDataProvider();
		this.currentGridView.setDataSource(this.currentDataProvider);		
		this.gridService.setDefaultSetting(this.currentGridView);
		this.currentGridView.setCheckBar({visible: false});
		this.currentGridView.setDisplayOptions({fitStyle: 'evenFill', rowHeight: 24, vscrollBar: true}); 
		this.currentGridView.setEditOptions({deletable: true});
		this.currentGridView.setSortingOptions({enabled: false});
		this.currentGridView.setHeader({height: 30});
		
		this.currentDataProvider.setFields(this.getVersionFields());
		this.currentGridView.setColumns(this.getVersionColumns());
		this.currentGridView.setSelectOptions({style: 'block'});
		
		this.currentGridView.onTopItemIndexChanged = (grid, itemIndex) => {
			if(grid.getTopItem() === itemIndex) {
				this.depGridView.setTopItem(itemIndex);
			}
		};
	}
	
	getVersionFields() {
		return [
			 {fieldName: "fldUnqId"},  {fieldName: "msgLayoutId"},
			 {fieldName: "fldEngNm"}, {fieldName: "fldKorNm"}, {fieldName: "dataTypeNm"}, 
			 {fieldName: "fldLvNo"}, {fieldName: "arraySizeRefVal"}, {fieldName: "msgLen"},
			 {fieldName: "srcData"}, {fieldName: "trgData"}
		];
	}
	
	getVersionColumns() {
		return  [
			{ 
				name: "fldEngNm", fieldName: "fldEngNm", header : { text: this.text.fldEngNm }, 
				width: 300, styles: { textWrap: 'ellipse' },
				dynamicStyles: [				
					{ criteria: 'values["fldLvNo"] = 1', styles: {paddingLeft: '10px'} },
					{ criteria: 'values["fldLvNo"] = 2', styles: {paddingLeft: '20px'} },
					{ criteria: 'values["fldLvNo"] = 3', styles: {paddingLeft: '30px'} },
					{ criteria: 'values["fldLvNo"] = 4', styles: {paddingLeft: '40px'} },
					{ criteria: 'values["fldLvNo"] = 5', styles: {paddingLeft: '50px'} },
					{ criteria: 'values["fldLvNo"] = 6', styles: {paddingLeft: '60px'} }
				]
			},
			{
				name: "fldKorNm", fieldName: "fldKorNm", header : { text: this.text.fldKorNm }, 
				width: 200, styles: { textWrap: 'ellipse' }
			},
			
			this.gridService.getSelectionEditorColumn({ 
				name: "dataTypeNm", fieldName: "dataTypeNm", header : { text: this.text.dataTypeNm }, 
				width: 200, styles: { textAlignment: 'center', textWrap: 'ellipse' }
			}, this.dataTypeList),
			{ 
				name: "fldLvNo", fieldName: "fldLvNo", header : { text: this.text.fldLvNo }, 
				width: 100, styles: { textAlignment: 'center', textWrap: 'ellipse' }
			},
			{ 
				name: "arraySizeRefVal", fieldName: "arraySizeRefVal", header : { text: this.text.arraySizeRefVal }, 
				width: 150, styles: { textAlignment: 'center', textWrap: 'ellipse' } 
			},
			{ 
				name: "msgLen", fieldName: "msgLen", header : { text: this.text.msgLen }, 
				width: 100, styles: { textAlignment: 'center', textWrap: 'ellipse' }
			}
		];
	}
	
	getDeployList(goToFirst = false) {
		const {pageNumber, pageSize} = this.getPageInfo();
		var url = `/intrfccoms/deployhistorys?deployResultCd=SUCCESS&pageNumber=${ goToFirst ? 1 : pageNumber}
				&pageSize=${pageSize}&intrfcId=${this.data.intrfcId}`;
		
		this.httpService.get(url).then(data => {
			if(goToFirst) {
				this.pageNumber = 1;
				this.$scope.$broadcast(`resetPage`, this.pageNumber);
			}
			
			this.recordsCount = data.totalCnt;
			this.dataProvider.setRows(data.intrfcdeployhisthsOutList);
		});
	}
	
	getMsglayout() {
		
		if(this.data.gridData){
			const res = this.data.gridData;
			this.currentRows = res.msglayoutdtDto;
			this.currentRows.msgRvsNo = res.msgRvsNo;
			this.currentDataProvider.setRows(res.msglayoutdtDto);
		}
		else{
			const msgLayoutId = encodeURIComponent(this.data.msgLayoutId);
			this.httpService.get(`/msglayouts/${msgLayoutId}`).then(res => {
				this.currentRows = res.msglayoutdtDto;
				this.currentRows.msgRvsNo = res.msgRvsNo;
				this.currentDataProvider.setRows(res.msglayoutdtDto);
			});
		}
	}
	
	getLayoutDiff(deployVersion){
		const data = this.data;
		const url = `/intrfccoms/layoutdiff?intrfcId=${data.intrfcId}&msgLayoutId=${data.msgLayoutId}
			&srTypeCd=${data.srTypeCd}&rqstRspsTypeCd=${data.rqstRspsTypeCd}
			&layoutSeq=${data.layoutSeq}&deployVersion=${deployVersion}`;
		
		this.httpService.get(url).then(data => {
			if (data.isError) {
				this.depDataProvider.setRows([]);
				this.popupService.simpleAlert(this.$scope, data.data.message);
				return;	
			}
			
			this.depRows = data.msglayoutdtDto;
			this.depRows.msgRvsNo = data.msgRvsNo;
			this.depDataProvider.setRows(data.msglayoutdtDto);
			this.currentDataProvider.setRows(this.currentRows);
			
			this.mapping();
		});
	}
	
	getPageInfo() {
		return {
			pageNumber: this.pageNumber || 1,
			pageSize: this.select.pageSize
		};
	}
	
	mapping(){
		let trgRows =  this.currentDataProvider.getJsonRows();
		let srcRows =  this.depDataProvider.getJsonRows();
		
		let targetCriteria= [];
		let targetStyles = [];
		let srcCriteria= [];
		let srcStyles = [];
		
		if(trgRows.length === 0) return;
		
		let i;
		
		for(i = 0; i < trgRows.length; i++) {
			let trgRow = trgRows[i];
			let fldEngNm = trgRow.fldEngNm;
			
			if(fldEngNm) {
				let trgPos = trgRows.indexOf(trgRow);
				let srcRow = srcRows.filter(rec => rec.fldEngNm === fldEngNm)[0];
				
				if(!_.isEmpty(srcRow)){
					let srcPos = srcRows.indexOf(srcRow);
					
					if(trgPos !== srcPos) {
						let diffPos = srcPos - trgPos;
						for(let j=0; j<diffPos; j++){
							trgRows.splice(trgPos, 0, { fldUnqId: this.utilService.uniqueId('TEMP_LAYOUT_DD_DTO_ID') });
						}
					}
				}else{
					srcRows.splice(trgPos, 0, { fldUnqId: this.utilService.uniqueId('TEMP_LAYOUT_DD_DTO_ID') });
				}
			}
		}
		
		let currentLength = trgRows.length;
		let oldLength = srcRows.length;
		
		if(currentLength < oldLength) {
			let diffLength = oldLength - currentLength;
			for(let j=0; j<diffLength; j++){
				trgRows.push({ fldUnqId: this.utilService.uniqueId('TEMP_LAYOUT_DD_DTO_ID') });
			}
		}
		
		trgRows.map((v, idx) => { v.itemIndex = idx; });
		srcRows.map((v, idx) => { v.itemIndex = idx; });
		
		this.currentDataProvider.setRows(trgRows);
		this.depDataProvider.setRows(srcRows);
		
		for(i=0; i<trgRows.length; i++) {
			let trgRow = trgRows[i];
			let srcRow = srcRows[i];
			
			if(!trgRow.fldEngNm) {
				// 삭제
				srcCriteria.push('row = ' + srcRow.itemIndex);
				srcStyles.push('background=#ffd8cd');
			}
			
			if(!srcRow.fldEngNm) {
				// 추가
				targetCriteria.push('row = ' + trgRow.itemIndex);
				targetStyles.push('background=#caddec');
			}
			
			if(trgRow.fldEngNm && srcRow.fldEngNm) {
				if(!(trgRow.dataTypeNm === srcRow.dataTypeNm && trgRow.msgLen === srcRow.msgLen)) {
					// 타입 또는 길이가 다를때 
					srcCriteria.push('row = ' + srcRow.itemIndex);
					srcStyles.push('background=#ffffbf');
					
					targetCriteria.push('row = ' + trgRow.itemIndex);
					targetStyles.push('background=#ffffbf');
				}
			}
		}
		
		// 그리드 diff 표시 
		this.currentGridView.setStyles({
			body: {
				dynamicStyles: [{
					criteria: targetCriteria,
					styles: targetStyles
				}]
			}
		});
		
		this.depGridView.setStyles({
			body: {
				dynamicStyles: [{
					criteria: srcCriteria,
					styles: srcStyles
				}]
			}
		});
	}
	
	pageBtnClick(num){
		this.pageNumber = num;
		this.getDeployList(num === 1);
	}
	
	closeModal(isOk){
		this.$uibModalInstance.dismiss();
		
		this.gridView.destroy();
		this.dataProvider.destroy();
		this.depGridView.destroy();
		this.depDataProvider.destroy();
		this.currentGridView.destroy();
		this.currentDataProvider.destroy();
	}
	
	setGridHeight() {
		let $msgGrid = $('#grid');
		let height = this.gridService.getGridHeight(this.select.pageSize);
		
		$msgGrid.height(height);
	}
}

module(App.name).controller('SCR0706Controller', SCR0706Controller);



// WEBPACK FOOTER //
// ./src/app/views/popup/SCR0706/SCR0706.controller.js